import { VuexModule, Module, Mutation } from 'vuex-module-decorators';

@Module({ namespaced: true })
class Appbar extends VuexModule {
    public status = {
        drawer: false,
        carrinhoDrawer: false
    }

    get getAppbarStatus() {
        return this.status;
    }

}

export default Appbar;